<template>
  <section class="p-6 flex flex-col gap-6">
    <nav class="text-gray-600 text-sm">
      <span class="font-semibold cursor-pointer" @click="router.push('/')">Home</span>
      <span class="mx-2">/</span>
      <span class="cursor-pointer font-semibold" @click="router.push({ name: 'Services' })">Services</span>
      <span class="mx-2">/</span>
      <span class="text-gray-800 font-bold">Add Service</span>
    </nav>

    <h3 class="font-bold text-2xl">Add Service</h3>

    <form @submit.prevent="submitForm" class="bg-white shadow rounded-lg p-6 flex flex-col gap-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Name (Arabic)</label>
          <input v-model="form.name_ar" class="border w-full rounded-md px-3 py-2" />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Name (English)</label>
          <input v-model="form.name_en" class="border w-full rounded-md px-3 py-2" />
        </div>

        <div>
          <label class="block text-sm font-medium mb-1">Category</label>
          <select v-model="form.category" class="border w-full rounded-md px-3 py-2">
            <option value="translation">Translation</option>
            <option value="academic">Academic</option>
            <option value="religious">Religious</option>
          </select>
        </div>
      </div>

      <!-- Short Description (AR/EN) -->
      <!-- <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Short Description (Arabic)</label>
          <input v-model="form.short_description_ar" class="border w-full rounded-md px-3 py-2" />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Short Description (English)</label>
          <input v-model="form.short_description_en" class="border w-full rounded-md px-3 py-2" />
        </div>
      </div> -->

      <!-- Full Description (AR/EN) -->
      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Full Description (Arabic)</label>
          <textarea v-model="form.description_ar" rows="4" class="border w-full rounded-md px-3 py-2"></textarea>
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Full Description (English)</label>
          <textarea v-model="form.description_en" rows="4" class="border w-full rounded-md px-3 py-2"></textarea>
        </div>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <label class="block text-sm font-medium mb-1">Price Text</label>
          <input v-model="form.price_text" class="border w-full rounded-md px-3 py-2" />
        </div>
        <div>
          <label class="block text-sm font-medium mb-1">Sort Order</label>
          <input v-model="form.sort_order" type="number" class="border w-full rounded-md px-3 py-2" />
        </div>
      </div>

      <div>
        <label class="block text-sm font-medium mb-1">Icon (optional)</label>
        <input type="file" @change="onFileChange" accept="image/*" />
        <img v-if="preview" :src="preview" class="mt-2 w-16 h-16 object-contain" />
      </div>

      <div>
        <label><input type="checkbox" v-model="form.is_active" /> Active</label>
      </div>

      <button type="submit" class="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 self-end">
        Save
      </button>
    </form>
  </section>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import apiClient from "@/apiClient";

const router = useRouter();

const form = ref({
  name_ar: "",
  name_en: "",
  category: "translation",

  short_description_ar: "",
  short_description_en: "",

  description_ar: "",
  description_en: "",

  price_text: "",
  sort_order: 0,
  is_active: true,
});

const iconFile = ref(null);
const preview = ref(null);

function onFileChange(e) {
  const file = e.target.files[0];
  if (!file) return;
  iconFile.value = file;
  preview.value = URL.createObjectURL(file);
}

async function submitForm() {
  const fd = new FormData();
  for (const key in form.value) fd.append(key, form.value[key]);
  if (iconFile.value) fd.append("icon", iconFile.value);

  try {
    await apiClient.post("/admin/services", fd, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    alert("Service added successfully!");
    router.push({ name: "Services" });
  } catch (err) {
    alert("Failed to add service.");
  }
}
</script>
